import Vue from 'vue';
import Router from 'vue-router';

const _import = require('./_import_' + process.env.NODE_ENV)
// in development-env  do not use lazy-loading, because  building apps with a bundler, the JavaScript bundle can become quite large, and thus affect the page load time. so only in production  will use lazy-loading;
// detail: https://router.vuejs.org/en/advanced/lazy-loading.html


Vue.use(Router);

/* Layout */
import Layout from '../views/layout/layout.vue'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']     will control the page roles (you can set multiple roles)
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
    noCache: true                if fasle ,the page will no be cached(default is false)
  }

 **/
  //TODO split this to Async route Maps to restrict access  to the routes
export const constantRouterMap = [
    {
      path: '/',
      component: _import('home/Home'),
      redirect: 'home',

      meta: {isHomeNavItem: true},
      children: [{
        path: 'home', component: _import('home/components/content/home_content'), name: 'Home', meta: {
          title: 'Home', index: '1'
        }
      },
        {
          path: 'about',
          beforeEnter:(to, from, next)=> {
            // Put the full page url including the protocol http(s) below
            window.location = "https://tisalabs.com/tisaiot/"
          },
          component: _import('home/components/content/about'), name: 'about', meta: {
            title: 'About', index: '2'
          },

        },
        // {
        //   path: 'how-to', component: _import('home/components/content/howTo'), name: 'HowTo', meta: {
        //     title: 'How to2', index: '3'
        //   }
        // }

      ]
    },
    // {path: '/404', component: _import('errorPage/404'), hidden: true},
    // {path: '/401', component: _import('errorPage/401'), hidden: true},
    {
      path: '',
      component: Layout,
      redirect: '/dashboard',
      meta: {roles: ['user'], requiresAuth: true},
      children: [{
        path: 'dashboard',
        component: _import('dashboard/Dashboard'),
        name: 'dashboard',
        meta: {title: 'Dashboard', icon: 'icon-dashboard', noCache: true}
      }]
    },

    {
      path: '/analytics',
      component: Layout,
      redirect: '/analytics/index',
      meta: {roles: ['user'], requiresAuth: true},
      children: [{
        path: 'index',
        component: _import('analytics/index'),
        name: 'analytics',
        meta: {
          title: 'Analytics',
          icon: 'icon-analytics',
        }
      }]

    },
    {
      path: '/projects',
      component: Layout,
      redirect: 'noredirect',
      meta: {isDropDown: true, title: 'Projects', icon: 'icon-devices', roles: ['user'], requiresAuth: true},
      name: 'projects',

    },
    {
      path: '/monitoring',
      component: Layout,
      redirect: '/monitoring/index',
      meta: {roles: ['user'], requiresAuth: true},
      children:
        [{
          path: 'index',
          component: _import('monitoring/index'),
          name: 'monitoring',
          meta: {
            title: 'Monitoring',
            icon: 'icon-monitoring',
          }
        }]
    },
    {
      path: '/blueprint',
      component:
      Layout,
      redirect:
        '/blueprint/index',
      meta: {roles: ['user'], requiresAuth: true},
      children:
        [{
          path: 'index',
          component: _import('blueprints/index'),
          name: 'blueprint',
          meta: {
            title: 'Blueprint',
            icon: 'icon-blueprint',
          }
        }]

    },

    {
      path: '/help',
      component:
      Layout,
      redirect:
        '/help/index',
      meta: {roles: ['user'], requiresAuth: true},
      children:
        [{
          path: 'index',
          component: _import('help/index'),
          name: 'help',
          meta: {
            title: 'Help',
            icon: 'icon-help',
          }
        }]

    },
    {
      path: '/project',
      component:
      Layout,
      redirect:
        '/project/index',
      hidden: true,
      meta: {roles: ['user'], requiresAuth: true},
      children:
        [{
          path: 'index/:id',
          component: _import('project/index'),
          name: 'project',
          meta: {
            title: 'Help',
            icon: 'icon-help',
          }
        }]

    }

  ]
;


export default new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({y: 0}),
  routes: constantRouterMap
})


///this is going to be used when for testing roles and user authentication  not used at the moment
export const asyncRouterMap = [

  {
    path: '/analytics',
    component: Layout,
    redirect: '/analytics/index',
    // meta: {roles: ['admin']}, this is for future implementation of policies
    children: [{
      path: 'index',
      component: _import('analytics/index'),
      name: 'analytics',
      meta: {
        title: 'analytics',
        icon: 'lock',
        // roles: ['admin'] // or you can only set roles in sub nav
      }
    }]

  }, {
    path: '/analytics',
    component: Layout,
    redirect: '/analytics/index',
    // meta: {roles: ['admin']}, this is for future implementation of policies
    children: [{
      path: 'index',
      component: _import('analytics/index'),
      name: 'analytics',
      meta: {
        title: 'analytics',
        icon: 'lock',
        // roles: ['admin'] // or you can only set roles in sub nav
      }
    }]

  }, {
    path: '/analytics',
    component: Layout,
    redirect: '/analytics/index',
    // meta: {roles: ['admin']}, this is for future implementation of policies
    children: [{
      path: 'index',
      component: _import('analytics/index'),
      name: 'analytics',
      meta: {
        title: 'analytics',
        icon: 'lock',
        // roles: ['admin'] // or you can only set roles in sub nav
      }
    }]

  },


];



// WEBPACK FOOTER //
// ./src/router/index.js